<mat-chip-list>
  <mat-chip class="mat-basic-chip chip-new"
            selected>BETA</mat-chip>
</mat-chip-list>
